module.exports = __webpack_public_path__ + "static/media/porteur.a2fa994b.png";